// @flow

import React from "react"
import styled from "styled-components"
import { colorGray, colorBlue } from "../../utils/design"

const Text = styled.p`
  font-size: ${props => (props.small ? 14 : 16)}px;
  font-weight: bold;
  color: #${props => (props.blue ? colorBlue : colorGray)};
  text-decoration: ${props => (props.underline ? "underline" : "none")};
  cursor: ${p => p.onClick && "pointer"};
  margin: 0px;
  padding: 0px;
`

type Props = {
  children: string,
  small?: boolean,
  underline?: boolean,
  blue?: boolean,
  onClick?: Function
}

const LabelPrimary = ({
  children,
  small,
  underline,
  blue,
  onClick,
  ...rest
}: Props): React$Element<any> => (
  <Text
    {...rest}
    small={small}
    underline={underline}
    blue={blue}
    onClick={onClick}
  >
    {children}
  </Text>
)

export default LabelPrimary
